import { CustomState } from "@iewc/Store/Reducers";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    LoadCart,
    PopulateApiParameter,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetCheckoutPaymentMethod";
import { PaymentMethodDto } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState() as CustomState;

    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to set a payment method on it.");
    }

    const defaultPaymentMethod = {
        paymentMethod: {
            // need to set name to empty string when removing payment method
            name: "",
        } as PaymentMethodDto,
    };

    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/PaymentMethodChanged",
        paymentMethod: props.parameter.paymentMethod ? props.parameter.paymentMethod : defaultPaymentMethod,
    } as any);
});

replaceInChain(chain, UpdateCart, props => {});

replaceInChain(chain, LoadCart, props => {});
